var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"skeleton-bloco-resumo-analise-eligibilidade"}},[_c('el-skeleton',{attrs:{"loading":_vm.carregando,"animated":""}},[_c('template',{slot:"template"},[_c('div',{staticClass:"skeleton-bloco-interno"},[_c('el-skeleton-item',{staticClass:"dado-icone",attrs:{"variant":"rect"}})],1)]),[_vm._t("default")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }